import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getNutData, updateNutData } from "../../../../store/actions";
import { get } from "lodash";
import NutrientDataForm from "./nutrientDataForm";

const NutrientData = ({ foodId, nutData, getNutData, initialValues, updateNutData, setActiveTab, isView }) => {
	useEffect(() => {
		getNutData(foodId);
	}, [foodId, getNutData]);

	const [fields, setFields] = useState({});
	const [nutDataState, setNutDataState] = useState([]);

	useEffect(() => {
		const d = {};
		nutData.reverse().map((item) => {
			return (d[`field_${item.id}`] = item.nut_val);
		});
		setFields(d);
		sort(nutData)
	}, [nutData]);

	const sort = (list) => {
		let data = list
		let result = []
		let lastItem = ""
		let keyItem = ""
		let increment = 1
		let keyIncrement = 1

		while (data.length) {
			if (data.length > 1) {
				lastItem = data[data.length - 1]
				keyIncrement = 1
				while (keyIncrement <= data.length) {
					keyItem = data[data.length - keyIncrement]

					if (lastItem.nut_data.name > keyItem.nut_data.name) {
						lastItem = keyItem
					}
					keyIncrement++;
				}
				result.push(lastItem)

				let list = []
				keyIncrement = 0
				while (keyIncrement < data.length) {
					keyItem = data[keyIncrement]
					if (keyItem.id !== lastItem.id) {
						list.push(keyItem)
					}
					keyIncrement++
				}
				data = list
			} else {
				result.push(data[0])
				data = []
			}
			increment++;
		}

		setNutDataState(result)
	}

	return initialValues && initialValues.id && nutDataState && nutDataState.length > 0 && fields ? (
		<React.Fragment>
			<div className="p-4">
				<div className="text-primary-dark mb-3">Base weight of {initialValues.base_weight} grams</div>
				<NutrientDataForm
					isView={isView}
					setActiveTab={setActiveTab}
					initialValues={fields}
					list={nutDataState}
					foodId={foodId}
					onSubmit={(values) => {
						values && updateNutData(values, () => getNutData(foodId));
						setActiveTab(2);
					}}
				/>
			</div>
		</React.Fragment>
	) : (
		<div className="alert alert-info text-center m-3 no-exercises-found">
			<div>No data found!</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		nutData: get(state, "FoodDatabase.nutData", []),
	};
};

const mapDispatchToProps = { getNutData, updateNutData };

export default connect(mapStateToProps, mapDispatchToProps)(NutrientData);
